import React, { useEffect, useState } from "react";
import shallow from "zustand/shallow";
import useStore from "stores/index";
import { getSupportContactDetails } from "stores/classwizeConfigStore";

const SupportDetails = () => {
	const [contactDetails, updateContactDetails] = useState(0);
	const [isFetching] = useState(0);

	useEffect(() => {
		updateContactDetails(getSupportContactDetails(useStore.getState()));
		const unsubClasswizeConfig = useStore.subscribe(
			(state) => [state.classwizeConfig.data],
			() => updateContactDetails(getSupportContactDetails(useStore.getState())),
			shallow
		);

		return () => {
			unsubClasswizeConfig();
		};
	}, []);

	const hasDetails = () => {
		if (Object.keys(contactDetails).length !== 0) {
			for (const key of ["support_contact_phone", "support_contact_name", "support_contact_email"]) {
				const value = contactDetails[key];
				if (value) {
					return true;
				}
			}
		}
	};

	if (isFetching) {
		return <div>Loading contact details...</div>;
	}

	if (!hasDetails()) {
		return <div>It looks like your administrator hasn't configured an in-school contact for Classwize.</div>;
	}

	return (
		<div>
			{contactDetails.support_contact_name && (
				<div className="SupportDetails_row">
					<div className="SupportDetails_label">Name:</div>
					<div>{contactDetails.support_contact_name}</div>
				</div>
			)}
			{contactDetails.support_contact_email && (
				<div className="SupportDetails_row">
					<div className="SupportDetails_label">Email:</div>
					<div>
						<a href={"mailto:" + contactDetails.support_contact_email}>{contactDetails.support_contact_email}</a>
					</div>
				</div>
			)}
			{contactDetails.support_contact_phone && (
				<div className="SupportDetails_row">
					<div className="SupportDetails_label">Phone:</div>
					<div>{contactDetails.support_contact_phone}</div>
				</div>
			)}
		</div>
	);
};

export default SupportDetails;
